export function getUniqueId() {
    return Date.now().toString(36) + Math.random().toString(36).slice(0, 6);
}

export function isServerSide() {
    return typeof window === 'undefined'
}